function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.502,1.004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.942,11.693L8.14,21.682C8.026,21.875 7.826,21.994 7.608,21.996L7.603,21.996C7.387,21.996 7.185,21.88 7.071,21.692L1.118,11.797C0.384,10.578 -0.001,9.171 -0.001,7.729C-0.001,3.465 3.362,-0.004 7.499,-0.004C11.634,-0.004 14.997,3.465 14.997,7.729C14.997,9.129 14.633,10.498 13.942,11.693ZM7.499,1.276C4.053,1.276 1.24,4.177 1.24,7.729C1.24,8.931 1.57,10.102 2.181,11.117L7.592,20.113L12.867,11.031C13.444,10.038 13.753,8.895 13.753,7.729C13.753,4.177 10.945,1.276 7.499,1.276ZM7.499,11.598C5.404,11.598 3.747,9.849 3.747,7.729C3.747,5.598 5.431,3.864 7.499,3.864C9.565,3.864 11.248,5.598 11.248,7.729C11.248,9.825 9.618,11.598 7.499,11.598ZM7.499,5.143C6.119,5.143 4.989,6.308 4.989,7.729C4.989,9.155 6.114,10.316 7.499,10.316C8.906,10.316 10.004,9.135 10.004,7.729C10.004,6.308 8.876,5.143 7.499,5.143Z",
    style: {
      fill: "white"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d3bc08f9d0beeeb8f324de26a51732b7.svg";
export { ForwardRef as ReactComponent };